import Action from "./action";

export default class LoadEvents extends Action {
    events;

    constructor(props) {
        super(props);
        this.events = props.events || [];
    }

    async execute(eventLoop) {
        if (!this.events || this.events.length === 0) {
            return;
        }
        const eventNames = this.events
            .map(t => (typeof t === 'string' ? t : (t?.text ?? t?.alias ?? t)))
            .filter(Boolean);
        console.log('load event', eventNames);
        await this.insertEventActions(eventLoop);
    }

    async insertEventActions(eventLoop) {
        const currentTimeline = eventLoop.actionQueue.getCurrentTimeline();
        if (!currentTimeline) {
            console.warn('No current timeline found to insert event actions');
            return;
        }
        if (!currentTimeline.events || !Array.isArray(currentTimeline.events)) {
            console.warn('No events found in current timeline');
            return;
        }

        const timeLineDuration = currentTimeline.actionSequence[0]?.timeLineDuration || 0;
        const allEventActionProps = [];

        for (let eventAlias of this.events) {
            const alias = typeof eventAlias === 'string' ? eventAlias.trim() : eventAlias;
            if (!alias) continue;

            for (let evt of currentTimeline.events) {
                if (evt.alias === alias) {
                    if (evt.actionSequence && Array.isArray(evt.actionSequence)) {
                        for (const props of evt.actionSequence) {
                            allEventActionProps.push({ ...props, timeLineDuration });
                        }
                    }
                    break;
                }
            }
        }

        if (allEventActionProps.length > 0) {
            eventLoop.addActionsToQueue(currentTimeline, allEventActionProps);
        }
    }
}
